module.exports = __webpack_public_path__ + "static/media/checkboxChecked.093b5b11.svg";